var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.8027 0H2.19727C0.987207 0 0 0.986133 0 2.19727V16.8457C0 18.0527 0.982813 19.043 2.19727 19.043H22.8027C24.0098 19.043 25 18.0602 25 16.8457V2.19727C25 0.990234 24.0172 0 22.8027 0ZM22.4993 1.46484L12.5466 11.4176L2.50776 1.46484H22.4993ZM1.46484 16.5424V2.4936L8.51948 9.48774L1.46484 16.5424ZM2.50063 17.5781L9.55972 10.519L12.0332 12.9713C12.3195 13.2552 12.7816 13.2542 13.0667 12.969L15.4785 10.5573L22.4994 17.5781H2.50063ZM23.5352 16.5423L16.5143 9.52148L23.5352 2.50059V16.5423Z","fill":"white"}));
}

Mail.defaultProps = {"className":"mail","width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
